import { Component, OnDestroy, OnInit } from '@angular/core';
import { RacunInfoService } from '../racun-info/racun-info.service';
import { StatusRacuna, TipRacuna, VrstaRacuna, VezaniRacunDto, IzmeneOsnovicaClient, EvidentirajDokumentOPromeniCommand } from '@kodit/core/data-api';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { Subscription } from 'rxjs';
import { AlertService } from '@kodit/core/services';

@Component({
  selector: 'kodit-dokument-o-promeni-form',
  templateUrl: './dokument-o-promeni-form.component.html',
  styleUrls: ['./dokument-o-promeni-form.component.scss']
})
export class DokumentOPromeniFormComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();

  tipDokumenta: TipRacuna;
  vrstaRacuna: VrstaRacuna;
  useOnlyTipove: TipRacuna[] = [];
  useOnlyStatuse: StatusRacuna[] = [];
  selectedRacun: VezaniRacunDto;
  jeIzmenaOsnovice: boolean = true;

  constructor(
    public _dialogRef: DynamicDialogRef,
    public _dialogConfig: DynamicDialogConfig,
    private _izmenaOsnovicaClient: IzmeneOsnovicaClient,
    private _alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.tipDokumenta = this._dialogConfig.data?.tipDokumenta;
    this.vrstaRacuna = this._dialogConfig.data?.vrstaRacuna;
    this.setAutocompleteFilters();

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => this.save())
    );
  }

  private setAutocompleteFilters() {
    this.useOnlyTipove = this.tipDokumenta === TipRacuna.DOKUMENT_O_POVECANJU
      ? [TipRacuna.DOKUMENT_O_POVECANJU]
      : [TipRacuna.DOKUMENT_O_SMANJENJU];

    this.useOnlyStatuse = [StatusRacuna.NACRT, StatusRacuna.POSLATO, StatusRacuna.PRIHVACENO];
  }

  handleVezaniRacunChange(racun: VezaniRacunDto) {
    this.selectedRacun = racun;
  }

  handleVezaniRacunClear() {
    this.selectedRacun = null;
  }

  private save() {
    if (!this.selectedRacun) {
      this._alertService.addWarnMsg('Morate izabrati dokument.');
      return;
    }

    this._subs.add(
      this._izmenaOsnovicaClient.evidentirajDokumentOPromeni(
        new EvidentirajDokumentOPromeniCommand({
          dokumentId: this.selectedRacun.racunId,
          tipRacuna: this.tipDokumenta,
          izvornaFakturaId: this._dialogConfig.data.racunId
        })
      ).subscribe(result => {
        if (result.succeeded) {
          this._alertService.addSuccessMsg(result.messages[0]);
          this._dialogRef.close(result.data);
        } else {
          this._alertService.addWarnMsg(result.messages![0]);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}